/* eslint-disable jsx-a11y/no-noninteractive-element-interactions -- Modal owns the keyboard focus trap and Escape handling. */
import { useEffect, useRef } from "react";
import { createPortal } from "react-dom";
import { LuX } from "react-icons/lu";

export const EditorDialog = ({
  title,
  description,
  onClose,
  children,
  footer,
  busy = false,
}) => {
  const ref = useRef(null);
  useEffect(() => {
    const previous = document.activeElement;
    (
      ref.current?.querySelector(
        "input:not(:disabled),select:not(:disabled),textarea:not(:disabled)",
      ) || ref.current?.querySelector("button:not(:disabled)")
    )?.focus();
    return () => previous?.focus?.();
  }, []);
  const keyboard = (event) => {
    if (event.key === "Escape") {
      event.preventDefault();
      event.stopPropagation();
      if (!busy) onClose();
    }
    if (event.key !== "Tab") return;
    const fields = [
      ...ref.current.querySelectorAll(
        'button:not(:disabled),input:not(:disabled),select:not(:disabled),[tabindex="0"]',
      ),
    ].filter(
      (field) => !field.matches(":disabled") && !field.closest("[hidden]"),
    );
    const first = fields[0],
      last = fields[fields.length - 1];
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last?.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first?.focus();
    }
  };
  return createPortal(
    <div className="productDialogBackdrop">
      <button
        type="button"
        className="productDialogOverlay"
        aria-label="Cerrar ventana"
        disabled={busy}
        tabIndex={-1}
        onClick={onClose}
      />
      <div
        ref={ref}
        role="dialog"
        tabIndex={-1}
        aria-modal="true"
        aria-labelledby="product-dialog-title"
        className="productDialog"
        onKeyDown={keyboard}
      >
        <header>
          <div>
            <h2 id="product-dialog-title">{title}</h2>
            {description && <p>{description}</p>}
          </div>
          <button
            type="button"
            aria-label="Cerrar"
            disabled={busy}
            onClick={onClose}
          >
            <LuX />
          </button>
        </header>
        <div className="productDialogBody">{children}</div>
        {footer && <footer>{footer}</footer>}
      </div>
    </div>,
    document.body,
  );
};
